export default __webpack_public_path__ + "static/media/slack.181a812d.png";